var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98892 10H11.9668V12H3.98892V10ZM5.98338 18H1.99446V2H8.97507V7H13.9612V10.1L15.9557 8.1V6L9.9723 0H1.99446C1.4655 0 0.958197 0.210714 0.584164 0.585786C0.21013 0.960859 0 1.46957 0 2V18C0 18.5304 0.21013 19.0391 0.584164 19.4142C0.958197 19.7893 1.4655 20 1.99446 20H5.98338V18ZM3.98892 16H8.07756L8.97507 15.1V14H3.98892V16ZM16.1551 11C16.2548 11 16.4543 11.1 16.554 11.2L17.8504 12.5C18.0499 12.7 18.0499 13.1 17.8504 13.3L16.8532 14.3L14.759 12.2L15.7562 11.2C15.856 11.1 15.9557 11 16.1551 11ZM16.1551 14.9L10.072 21H7.97784V18.9L14.0609 12.8L16.1551 14.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEdit);
export default __webpack_public_path__ + "static/media/file-edit.6c901be0.svg";
export { ForwardRef as ReactComponent };